import { setNotificationImage, setNotifications, setSystemNotifications } from "../../state/ducks";
import { dispatch } from "../../state/store";
import { notificationUtils } from "../../utils";
import httpClient from "../httpClient";
import s3ImageService from "../image/s3ImageService";

const apiUrl = process.env.REACT_APP_SHARED_CORE_URL;

const getRequestData = (endpoint = "messages") => {
  return `${apiUrl}/notifications/${endpoint}`;
};

const fetchNotifications = async () => {
  const url = getRequestData();

  const result = await httpClient.get(`${url}?limit=250`);

  if (result?.data?.data) {
    dispatch(setNotifications(result.data.data));
    await fetchNotificationImages(result.data.data);
  }

  return result.data.data;
};

const createNotification = async (notification) => {
  const url = getRequestData();

  return await httpClient.post(url, { data: notification });
};

const updateNotification = async (notification) => {
  const url = getRequestData();

  return await httpClient.put(url, { data: notification });
};

const fetchSystemNotifications = async () => {
  const url = getRequestData("systemMessages");

  const result = await httpClient.get(`${url}?limit=250`);

  let formattedNotifications = [];

  if (result?.data?.data) {
    formattedNotifications = notificationUtils.formatSystemNotifications(result?.data?.data);

    dispatch(setSystemNotifications(formattedNotifications));
    await fetchNotificationImages(formattedNotifications);
  }

  return formattedNotifications;
};

const fetchNotificationImages = async (notifications) => {
  const res = await Promise.all(
    notifications?.map((notification) => {
      const isSystemNotification = notification?.isSystemNotification ?? false;
      return downloadImage(notification.notificationName, notification.image, isSystemNotification);
    })
  );

  return res;
};

const createSystemNotification = async (notification) => {
  const url = getRequestData("systemMessages");

  return await httpClient.post(url, { data: notification });
};

const updateSystemNotification = async (notification) => {
  const url = getRequestData("systemMessages");

  return await httpClient.put(url, { data: notification });
};

const downloadImage = async (notificationName, imageUrl, isSystemNotification) => {
  const { imageFile, imageSrc } = (await s3ImageService.downloadImage(imageUrl)) ?? {};

  if (imageFile && imageSrc && notificationName) {
    const notificationImage = { notificationName, imageFile, imageSrc, isSystemNotification };
    dispatch(setNotificationImage(notificationImage));

    return imageFile;
  }
};

const notificationManagementService = {
  fetchNotifications,
  createNotification,
  updateNotification,
  fetchSystemNotifications,
  createSystemNotification,
  updateSystemNotification
};

export default notificationManagementService;
